import { render, staticRenderFns } from "./gradeChart.vue?vue&type=template&id=01f0cf19&"
import script from "./gradeChart.vue?vue&type=script&lang=js&"
export * from "./gradeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports